import React, { useState } from 'react'
import Loading from '../common/Loading'
import { Avatar } from '@readyplayerme/visage'

const AvatarScene = ({ avatarUrl, animationSrc }) => {
  const [avatarLoaded, setAvatarLoaded] = useState(false)

  const onLoaded = () => {
    setAvatarLoaded(true)
  }

  return (
    <div>
      <div className="h-80 w-full  bg-[url('/images/banner.png')] bg-bottom relative">
        {!avatarLoaded && (
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <Loading />
          </div>
        )}
        <Avatar
          shadows={true}
          cameraTarget={2}
          onLoaded={onLoaded}
          style={{ height: '100%' }}
          modelSrc={avatarUrl}
          animationSrc={animationSrc}
          cameraInitialDistance={2}
        />
      </div>
    </div>
  )
}

export default AvatarScene
